import {
  Order as OrderStore,
  OrderAdjustments,
  PaymentOnSellThroughSettings,
  PaymentsInvoiceStatus,
} from '@/models/order';

import LineItem from './LineItem';

/**
 * Model for an Order. It contains the lineItems and meta data about the order.
 */
export default class Order implements OrderStore {
  public autoAuthorizationEnabled;
  public buyerApproved;
  public classification;
  public createdBy;
  public createdOn;
  public creditsApplied;
  public customer;
  public customerGroupId;
  public deliveryAddress;
  public discount;
  public facilities;
  public hasInvisibleLineItems;
  public isAutolocked;
  public isCollaborativeOrder;
  public isLocked;
  public isPaymentOnSellThrough;
  public isWarehouseOrder;
  public lineItems;
  public notes;
  public orderAdjustments: OrderAdjustments[];
  public orderNumber; // note: clones `uuid`, but needed for API
  public orderSellerNumber;
  public paymentOnSellThroughSettings: PaymentOnSellThroughSettings;
  public paymentsInvoiceStatus: PaymentsInvoiceStatus;
  public paymentTerm;
  public salesReps;
  public sellerId;
  public sellerLicenses;
  public shipDate;
  public shippingCharge;
  public status;
  public taxAmount;
  public taxes;
  public total;
  public user;
  public uuid;

  constructor(data) {
    this.autoAuthorizationEnabled = data.autoAuthorizationEnabled;
    this.buyerApproved = data.buyerApproved;
    this.user = data.user;
    this.uuid = this.orderNumber = data.orderNumber;
    this.orderSellerNumber = data.orderSellerNumber;
    this.customer = data.customer;
    this.customerGroupId = data.customerGroupId;
    this.deliveryAddress = data.deliveryAddress;
    this.sellerId = data.seller;
    this.sellerLicenses = data.sellerTransactionLicenses;
    this.status = data.status;
    this.notes = data.notes;
    this.total = data.total;
    this.salesReps = data.salesReps;
    this.shipDate = data.shipDate;
    this.createdOn = data.createdOn;
    this.createdBy = data.createdBy;
    this.classification = data.classification;
    this.lineItems = (data.lineItems || []).map((i) => new LineItem(i, data.status));
    this.creditsApplied = data.creditsApplied;
    this.shippingCharge = data.shippingCharge;
    this.hasInvisibleLineItems = data.hasInvisibleLineItems;
    this.paymentTerm = data.paymentTerm;
    this.isWarehouseOrder = data.isWarehouseOrder;
    this.isAutolocked = data.isAutolocked;
    this.isCollaborativeOrder = data.isCollaborativeOrder;
    this.isLocked = data.isLocked;
    this.facilities = data.warehouses;
    this.orderAdjustments = data.orderAdjustments;
    this.paymentsInvoiceStatus = data.paymentsInvoiceStatus;
    this.isPaymentOnSellThrough = data.isPaymentOnSellThrough;
    this.paymentOnSellThroughSettings = data.paymentOnSellThroughSettings;

    // TODO update after ENT2-818
    this.taxes = (data.taxes || []).map((tax) => {
      const taxDetail = data.orderTaxes.find((t) => t.id === tax.id);

      return {
        ...tax,
        enabled: true,
        state: taxDetail.state,
        name: taxDetail.name,
        rate: parseFloat(tax.rate),
      };
    });

    this.discount = {
      amount: data.discountAmount,
      type: data.discountType,
    };
  }
}
